import { render, staticRenderFns } from "./ProdManDataReport.vue?vue&type=template&id=4e13d16a&scoped=true&"
import script from "./ProdManDataReport.vue?vue&type=script&lang=js&"
export * from "./ProdManDataReport.vue?vue&type=script&lang=js&"
import style0 from "./ProdManDataReport.vue?vue&type=style&index=0&id=4e13d16a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e13d16a",
  null
  
)

export default component.exports